module.exports = __webpack_public_path__ + "img/coin.3743e35e.png";